import React, { useContext, useState } from 'react';
import { useIntl } from 'gatsby-plugin-intl';
import ReactCountryFlag from 'react-country-flag';
import { Link } from 'gatsby';

import LanguageContext from '../../contexts/LanguageContext';
import { Danish, English, French, German, Norwegian } from './LanguageSwitcher';

export const MobileMenu = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { changeLanguage, changeCurrency, currency } = useContext(LanguageContext);
  const { locale } = useIntl();

  const openMenu = () => {
    document.body.style = 'overflow: hidden;';
    setMenuOpen(true);
  };
  const closeMenu = () => {
    document.body.style = '';
    setMenuOpen(false);
  };

  return (
    <div className="block lg:hidden">
      <div className="cursor-pointer" onClick={openMenu}>
        <svg width="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21.6667 30H33.3334M6.66675 10H33.3334H6.66675ZM6.66675 20H33.3334H6.66675Z"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      {menuOpen ? (
        <div className="fixed top-0 left-0 w-screen h-screen flex flex-col justify-center bg-white p-8 md:p-12 pb-20 z-10">
          <div className="cursor-pointer absolute right-0 top-0 p-4 md:p-8" onClick={closeMenu}>
            <svg width="40" viewBox="0 0 32 32" fill="none">
              <path
                d="M13.3333 18.6667L16 16M16 16L18.6667 13.3333M16 16L13.3333 13.3333M16 16L18.6667 18.6667M28 16C28 17.5759 27.6896 19.1363 27.0866 20.5922C26.4835 22.0481 25.5996 23.371 24.4853 24.4853C23.371 25.5996 22.0481 26.4835 20.5922 27.0866C19.1363 27.6896 17.5759 28 16 28C14.4241 28 12.8637 27.6896 11.4078 27.0866C9.95189 26.4835 8.62902 25.5996 7.51472 24.4853C6.40042 23.371 5.5165 22.0481 4.91345 20.5922C4.31039 19.1363 4 17.5759 4 16C4 12.8174 5.26428 9.76516 7.51472 7.51472C9.76516 5.26428 12.8174 4 16 4C19.1826 4 22.2348 5.26428 24.4853 7.51472C26.7357 9.76516 28 12.8174 28 16Z"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <nav className="text-2xl font-heading flex flex-col items-center flex-1">
            <Link to={`/${locale}/`} className="p-4">
              Home
            </Link>
            <Link to={`/${locale}/screens`} className="p-6">
              Schutzfolien
            </Link>
          </nav>

          <div className="flex w-full">
            <div className="pr-5 flex-1">
              <div className="font-heading mb-2">Languages</div>
              <div className="py-1 inline-flex items-center cursor-pointer" onClick={() => changeLanguage('de')}>
                <German />
              </div>
              <div className="py-1 flex items-center cursor-pointer" onClick={() => changeLanguage('en')}>
                <English />
              </div>
              <div className="py-1 flex items-center cursor-pointer" onClick={() => changeLanguage('fr')}>
                <French />
              </div>
              <div className="py-1 flex items-center cursor-pointer" onClick={() => changeLanguage('da')}>
                <Danish />
              </div>
              {/* <div className="py-1 flex items-center cursor-pointer" onClick={() => changeLanguage('nb')}>
                <Norwegian />
              </div> */}
            </div>
            <div className="pl-5 flex-1 flex flex-col items-end">
              <div className="font-heading mb-2">Currencies</div>
              <div className="py-1 inline-flex items-center cursor-pointer" onClick={() => changeCurrency('EUR')}>
                <span>EUR</span>
                <ReactCountryFlag countryCode="EU" svg className="ml-1 block" />
              </div>
              {/* <div className="py-1 inline-flex items-center cursor-pointer" onClick={() => changeCurrency('GBP')}>
                <span>GBP</span>
                <ReactCountryFlag countryCode="GB" svg className="ml-1 block" />
              </div> */}
              {/* <div className="py-1 inline-flex items-center cursor-pointer" onClick={() => changeCurrency('USD')}>
                <span>USD</span>
                <ReactCountryFlag countryCode="US" svg className="ml-1 block" />
              </div> */}
              <div className="py-1 inline-flex items-center cursor-pointer" onClick={() => changeCurrency('DKK')}>
                <span>DKK</span>
                <ReactCountryFlag countryCode="DK" svg className="ml-1 block" />
              </div>
              {/* <div className="py-1 inline-flex items-center cursor-pointer" onClick={() => changeCurrency('NOK')}>
                <span>NOK</span>
                <ReactCountryFlag countryCode="NO" svg className="ml-1 block" />
              </div> */}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};
